export const environment = {
  production: true,
  apiBaseUrl: 'https://spin2winadminpanelapi.azurewebsites.net/',
  appVersion: '1.0.0',
  NgxStripeModule: 'pk_live_51IoNshFM2FNR3cWY14coFsASW1SyrVv6gSJHN3RlX6pDKksWT0pWX9uA1Eb4wfdRpp54sqrcHKEw2E5mkm07rql90091htzcRU',
  clientId:'973213910663-guvias34uvhpvpi2sel6mg7p55l1bgq3.apps.googleusercontent.com',
  heatMap:'5349957'
};
